function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a6c51dd9-18df-4652-a20c-08a14b52d8b3{fill:none;stroke:#f65e5c;stroke-width:10.4px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "aa553df5-5b5f-4ba1-a9cb-9a3744eae763",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "b4a9217d-106f-4b6c-b399-bed5709e5eb5",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "a6c51dd9-18df-4652-a20c-08a14b52d8b3",
  points: "45.86 243.4 5.86 243.4 34.56 5.2 113.76 5.2 45.86 243.4"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "a6c51dd9-18df-4652-a20c-08a14b52d8b3",
  points: "156.36 243.4 116.36 243.4 145.06 5.2 224.16 5.2 156.36 243.4"
})));

var SvgLogoIcon13 = function SvgLogoIcon13(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 231.05 248.6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoIcon13, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-icon (13).a80f8944.svg";
export { ForwardRef as ReactComponent };